module.exports = __webpack_public_path__ + "static/media/logo.b6d6174c.png";